import React from 'react';


export const Avatar = ({ src, size, radius, ...props }) => {
    return (
        <div style={ {
            backgroundColor: 'var(--white)',
            backgroundImage: src ? 'url(' + src + ')' : null,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            width: size ? size : '38px',
            height: size ? size : '38px',
            borderRadius: radius ? radius : '50%',
            border: 'solid 2px var(--white)',
            flexShrink: 0
        } }
            { ...props }
        />
    )
}
